import angular from "angular";
import htmlTemplate from "./project_edit.html";

export default angular
    .module("sbApp.sbProjectEdit", [])
    .directive(
        "sbProjectEdit",
        function (
            PROJECT_CONFIG,
            $sbTimezone,
            $sbFileReader,
            $sbErrorPresenter,
            $sbImageUpload,
            $sbFeatureDecisions,
            PageFlags
        ) {
            return {
                restrict: "E",
                templateUrl: htmlTemplate, //HTML Template as String
                controllerAs: "editProject",
                bindToController: true,
                scope: {
                    project: "=",
                    projectForm: "=",
                    creationMode: "=",
                },

                controller: function (
                    $sbProjectApi,
                    $translate,
                    $sbPermission,
                    LANGUAGES,
                    $timeout
                ) {
                    "ngInject";
                    /////////////////////
                    //
                    //      Direct variables
                    //
                    /////////////////////

                    var MAX_COVER_IMAGE_WIDTH = 700;
                    var MAX_COVER_IMAGE_HEIGHT = 700;

                    var vm = this;

                    /////////////////////
                    //
                    //      View model properties
                    //
                    /////////////////////

                    vm.availableLanguages = LANGUAGES;
                    vm.CONFIG = PROJECT_CONFIG;
                    vm.editAllowed = false;
                    vm.isSaved = false;
                    vm.showTimezoneEdit = false;
                    vm.creationDialog = false;
                    vm.currencyEditAllowed = false;

                    vm.allowedPictureExtension = [
                        ".png",
                        ".jpg",
                        ".jpeg",
                        ".gif",
                    ];

                    vm.image = {
                        url: null,
                    };

                    vm.availableCurrencies = ["USD", "EUR", "GBP", "AUD"];
                    vm.changeTimezone = changeTimezone;
                    vm.onPictureChange = onPictureChange;

                    _activate();

                    /////////////////////
                    //
                    //      IMPL
                    //
                    /////////////////////

                    function _activate() {
                        if (!vm.project) {
                            // we are in creation mode, so we initialize
                            vm.creationDialog = true;
                            var timezone = $sbTimezone.getDefaultTimezone();

                            vm.project = {
                                language: $translate.use().toUpperCase(),
                                TIMEZONE: timezone,
                            };
                            vm.editAllowed = true;
                            vm.showTimezoneEdit = true;
                        } else {
                            refreshProjectImage(
                                vm.project.id,
                                vm.project.imageId
                            );

                            vm.editAllowed =
                                $sbPermission.hasAdminPermissions(
                                    vm.project.privileges
                                ) || vm.creationMode;
                            vm.currencyEditAllowed =
                                $sbFeatureDecisions.isFeatureEnabled(
                                    PageFlags.CommercialValuation
                                );
                        }
                    }

                    function onPictureChange($event, file) {
                        return $sbFileReader
                            .readAndResizeImage(
                                file,
                                MAX_COVER_IMAGE_WIDTH,
                                MAX_COVER_IMAGE_HEIGHT
                            )
                            .then(function (result) {
                                return _uploadImage(
                                    result.rawData,
                                    result.fileName,
                                    vm.project.id
                                );
                            })
                            .catch($sbErrorPresenter.catch);
                    }

                    function _showSavedIndication() {
                        vm.isSaved = true;
                        return $timeout(function () {
                            vm.isSaved = false;
                        }, 1500);
                    }

                    function refreshProjectImage(projectId, imageId) {
                        return $sbProjectApi
                            .fetchLogo(projectId, imageId)
                            .then((image) => {
                                vm.image.url = image.dataUrl;
                            });
                    }

                    function _uploadImage(blob, fileName, projectId) {
                        return $sbImageUpload
                            .uploadImages(fileName, [blob], projectId)
                            .then(function (result) {
                                vm.project.imageId = result.id;
                                return $sbProjectApi.edit(vm.project);
                            })
                            .then(() =>
                                refreshProjectImage(
                                    vm.project.id,
                                    vm.project.imageId
                                )
                            )
                            .then(_showSavedIndication)
                            .catch($sbErrorPresenter.catch);
                    }

                    /**
                     * changeTimezone - When the language changes, update the current timezone
                     *
                     * @param  {String} language - Two char identifing the language (EN, DE, IT...)
                     */
                    function changeTimezone(language) {
                        vm.project.TIMEZONE =
                            $sbTimezone.getDefaultTimezone(language);
                    }
                },
            };
        }
    );
